import React from 'react';
import { useDispatch } from 'react-redux';

import { sendEmailVerification } from '../../app/actions/authActions';

import './styles.scss';

const AlertMessage = ({showAlert}) => {
	const dispatch = useDispatch();

	const handleGetEmail = (event) => {
		event.preventDefault();
		dispatch(sendEmailVerification());
	};

	return (
		<>
			{
				showAlert.message && (
					<div className={`alert-message alert-message--${showAlert.type}`}>
						{
							showAlert.type === 'emailVerify' ?  (
								<>Verify your email first. 
								<a href="/" 
									onClick={handleGetEmail}
								>
									Didn't get the email?
								</a></>
							) 
							: 
							showAlert.message
						}
					</div>
				)
			}
		</>
	);
};

export default AlertMessage;
